import { render } from "./DeliveryInstructions.vue?vue&type=template&id=16e3a608&scoped=true"
import script from "./DeliveryInstructions.vue?vue&type=script&lang=js"
export * from "./DeliveryInstructions.vue?vue&type=script&lang=js"

import "./DeliveryInstructions.vue?vue&type=style&index=0&id=16e3a608&lang=scss&scoped=true"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e3a608"]])

export default __exports__